export default __webpack_public_path__ + "static/media/achievement.c3eeecaf.webp";